export default __webpack_public_path__ + "static/media/message.348d691e.svg";